@use 'shared/styles/generated/tokens' as *;

.root {
  // Спека 02 §A1: композиция 64 / 22 сверху и по бокам. Screen.Content уже даёт 24px сверху
  // и 14px по бокам — здесь только дельта. Арифметики в SCSS быть не может: токены это
  // CSS-переменные, складывать их можно только через calc().
  padding: $space-large-l $space-medium-m 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: $space-medium-l;
  min-height: 100%;
}

.mascot {
  align-self: center;
}

/**
 * Слот вопроса о поле (A1·2). Место занято всегда, меняются только прозрачность и небольшой
 * сдвиг — так поле имени остаётся ровно на месте, пока пользовательница печатает.
 *
 * Своей высоты у слота нет. Раньше стояла фиксированная (`height: $control-height-s`) вместе
 * с `overflow: hidden`, и она была меньше реального содержимого — подпись «Ты у нас…?» плюс
 * ряд кнопок: кнопки обрезались ровно посередине, а экран при этом «влезал» в высоту и не
 * скроллился, потому что переполнения не возникало. Высоту задаёт само содержимое.
 */
.genderSlot {
  opacity: 0;
  // `-#{$token}` даёт `-var(--space-small-m)` — невалидный CSS, правило молча выбрасывается.
  // Минус к CSS-переменной применяется только через calc.
  transform: translateY(calc(-1 * #{$space-small-m}));
  pointer-events: none;
  transition:
    opacity $duration-normal $easing-out,
    transform $duration-normal $easing-out;
}

.genderSlotVisible {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}
